import React, { useEffect } from "react";
import styles from "./Menu.module.css";
import { setLockedViewport } from "../../services/service-utils";
import Navigation from "../Navigation/Navigation";

const Menu = ({ menuOpen, onItemClick }) => {
  useEffect(() => {
    if (menuOpen) {
      setLockedViewport(true);
    } else {
      setLockedViewport(false);
    }
    return () => setLockedViewport(false);
  }, [menuOpen]);

  return (
    <div className={menuOpen ? styles.MenuShow : styles.Menu}>
      <div className="container">
        <div className="row">
          <div className="col-xs-6 col-xs-offset-6">
            <Navigation
              className={styles.navigation}
              onItemClick={onItemClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
